import React from 'react';
import { buildWhatsAppHref, readSupportConfig, telHref } from '../utils/supportContact';
import './SecurityPages.css';

const SupportPage = ({ onNavigate }) => {
  const { phoneDisplay, emails, waDigits, waMessage, hours } = readSupportConfig();
  const waHref = buildWhatsAppHref(waDigits, waMessage);
  const phoneHref = telHref(phoneDisplay);

  const defaultHours = 'Monday–Friday: 08:00–18:00 (EAT) · Saturday: 09:00–13:00 · Sunday: closed — adjust to match your business if needed.';

  return (
    <div className="security-page security-page--support page-bleed">
      <header className="security-page-head">
        <button type="button" className="security-back" onClick={() => onNavigate?.('overview')}>
          ← Dashboard
        </button>
        <h1 className="security-title">Support &amp; call center</h1>
        <p className="security-lead">
          StockTrack help: phone, WhatsApp, email, and staffed hours (Fush Holdings).
        </p>
      </header>

      <div className="security-support-grid">
        <article className="security-support-card">
          <h2 className="security-support-card__title">Call center</h2>
          {phoneHref ? (
            <a className="security-support-card__link" href={phoneHref}>
              {phoneDisplay}
            </a>
          ) : (
            <p className="security-support-card__muted">
              Support phone number is not configured yet. Contact your account administrator or StockTrack provider for the
              direct line.
            </p>
          )}
        </article>

        <article className="security-support-card">
          <h2 className="security-support-card__title">WhatsApp</h2>
          {waHref ? (
            <a className="security-support-card__link" href={waHref} target="_blank" rel="noopener noreferrer">
              Open chat
            </a>
          ) : (
            <p className="security-support-card__muted">A WhatsApp link will appear here once your administrator adds a support number.</p>
          )}
        </article>

        <article className="security-support-card">
          <h2 className="security-support-card__title">Email</h2>
          {emails.length ? (
            <div className="security-support-card__stack">
              {emails.map((addr) => (
                <a
                  key={addr}
                  className="security-support-card__link"
                  href={`mailto:${encodeURIComponent(addr)}`}
                >
                  {addr}
                </a>
              ))}
            </div>
          ) : (
            <p className="security-support-card__muted">
              Support email is not set yet. Ask your administrator for the official address.
            </p>
          )}
        </article>

        <article className="security-support-card security-support-card--wide">
          <h2 className="security-support-card__title">Service hours</h2>
          <p className="security-support-card__body">{hours || defaultHours}</p>
        </article>
      </div>

      <section className="security-support-help">
        <h2 className="security-support-help__title">What we help with</h2>
        <ul className="security-support-help__list">
          <li>Sign-in, passwords, and staff accounts</li>
          <li>POS, stock, and payment issues</li>
          <li>Reports and day-to-day operations</li>
          <li>Safe usage guidance through the support team</li>
        </ul>
      </section>
    </div>
  );
};

export default SupportPage;
